import { Controller } from "@hotwired/stimulus"

/**
 * Audio Preview Controller
 *
 * Provides play/pause functionality for audio URL fields.
 * Shows/hides the play button based on whether there's a URL.
 */
export default class extends Controller {
  static targets = ["urlInput", "playButton", "audio", "playIcon", "pauseIcon"]

  connect() {
    this.isPlaying = false
    this.updateButtonVisibility()

    // Handle audio ended
    if (this.hasAudioTarget) {
      this.audioTarget.addEventListener("ended", () => this.onAudioEnded())
    }
  }

  disconnect() {
    this.stopAudio()
  }

  urlChanged() {
    this.updateButtonVisibility()
    this.stopAudio()
  }

  changeScene(event) {
    const url = event.target.value
    if (this.hasUrlInputTarget) {
      this.urlInputTarget.value = url
    }
    this.stopAudio()
  }

  updateButtonVisibility() {
    if (!this.hasPlayButtonTarget || !this.hasUrlInputTarget) return

    const url = this.urlInputTarget.value.trim()
    if (url) {
      this.playButtonTarget.classList.remove("hidden")
    } else {
      this.playButtonTarget.classList.add("hidden")
    }
  }

  togglePlay() {
    if (this.isPlaying) {
      this.stopAudio()
    } else {
      this.playAudio()
    }
  }

  async playAudio() {
    if (!this.hasAudioTarget || !this.hasUrlInputTarget) return

    const url = this.urlInputTarget.value.trim()
    if (!url) return

    try {
      this.audioTarget.src = url
      await this.audioTarget.play()
      this.isPlaying = true
      this.updateIcons()
    } catch (error) {
      console.error("Failed to play audio:", error)
      this.isPlaying = false
      this.updateIcons()
    }
  }

  stopAudio() {
    if (!this.hasAudioTarget) return

    this.audioTarget.pause()
    this.audioTarget.currentTime = 0
    this.isPlaying = false
    this.updateIcons()
  }

  onAudioEnded() {
    this.isPlaying = false
    this.updateIcons()
  }

  updateIcons() {
    if (!this.hasPlayIconTarget || !this.hasPauseIconTarget) return

    if (this.isPlaying) {
      this.playIconTarget.classList.add("hidden")
      this.pauseIconTarget.classList.remove("hidden")
    } else {
      this.playIconTarget.classList.remove("hidden")
      this.pauseIconTarget.classList.add("hidden")
    }
  }
}
